export const iconFontAwesomeEditingTrashArrowUp = (
	<i className="fa-solid fa-trash-arrow-up"></i>
);
